const Form070EN = {
    stepName: {
        Statement: "Important Notes",
        schoolInfo: "School Information",
        SectionA: "Section A",
        SectionB: "Section B",
        certification: "Section C Certification",
        signature: "Signature",
        Confirmation: "Confirmation",
    },
    label: {
        reasonOption: {
            a: "paid sick/maternity/special tuberculosis leave",
            b: "paid study leave",
            c: "paid study leave (specified professional development programmes attended by one or more teachers for 30 or more consecutive calendar days), please specify the course ID",
            d: "paid leave for teachers for juror or witness service",
            e: "paid paternity leave",
            f: "other paid leave ",
            x: "no-pay sick/maternity/special tuberculosis leave",
            y: "other no-pay leave",
        },
        surplusOption: {
            yes: "has",
            no: "has no",
        },
        formTypeOption: {
            N: "New",
            R: "Revised",
        },
        changePreClaimOption: {
            unDelete: "Unchange Previous Claim",
            delete: "Delete Previous Claim",
            change: "Change previous claim",
        },
        partBi:
            "B.\nFor temporary teachers appointed on monthly term, please submit appointment form available from EDB " +
            "Homepage (",
        partBii: "http://www.edb.gov.hk",
        partBiii:
            "→ School Administration and Management → Administration → About School Staff →" +
            " Appointment Matters)",
        partC: "Section C Certification",
        // note: "Important Notes",
        statement: "Personal Information Collection Statement",
        surplusTeachers: "Surplus teachers:",
        surplusNo: "No. of Surplus teachers",
        termsConditions:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        iamStatement:
            'I understand that an "iAM Smart+" account is required for processing the application.',
        headerOne: "School Information",
        schoolName: "Name of School",
        schoolCode: "School Code",
        Month: "Month",
        Year: "Year",
        headerTwoA:
            "A. Reimbursement of salaries and employer’s contributions to MPF schemes for eligible supply teachers arising from teacher(s) on leave lasting for 30 to 89 calendar days, or from teacher(s) on paternity leave lasting for 3 or more consecutive days",
        headerTwoB:
            ", or from number of teachers on leave for 3 or more consecutive days at the same time exceeds the number of surplus teacher(s) if your school ceased receiving annual recurrent grant of TRG in the school year after packing of classes.",
        headerTwoC:
            " (For supply teachers required to contribute to MPF, please provide supporting information of MPF if claim period is less than 60 days)",
        headerTwoNote1:
            "Schools could claim reimbursement of salaries of the supply teachers substituting the teachers remunerated under Salaries Grant who are on paternity leave, on condition that the teachers are approved to take leave for 3 or more consecutive days. For details, please refer to EDB Circular No. 16/2015.",
        headerTwoNote2:
            "For details, please refer to Annex IV of this guideline.",
        headerThree: "Teacher on leave",
        formType: "New/Revised form",
        changePreclaim:
            "Unchange previous claim/Delete previous claim/Change previous claim",
        preclaimNum:
            "Please indicate the Application Number of Previous Claim Form",
        previousDate: "Copy of Previous Claim Dated:",
        previousFormFile: "A Copy of Previous Claim:",
        applicationNum: "Application Number",

        leaveTeacherName: "Name",
        leaveTeacherSRN: "SRN",
        leaveTeacherReason: "Reason for absence",
        leaveTeacherPost: "Post",
        leaveDatelabel: "Leave period",
        leaveStartTime: "From",
        leaveEndTime: "To",
        supplyTeacherName: "Name of Supply Teacher",
        supplyDatelabel: "Supply period",
        supplyStartTime: "From",
        supplyEndTime: "To",
        workDaysNo: "No. of working days",
        DailyRate: "Daily rate",
        salaryAmount: "Salary amount",
        trusteeReceipt:
            "Attachment for the emoluments have been paid to the supply teacher(s) and/or MPF scheme trustee(s):",
        MPFSubsidy: "MPF Subsidy",
        contractDatelabel: "Contract period",
        contractStartTime: "From",
        contractEndTime: "To",
        MPFfile: "Attachment for the supporting information of MPF:",
        totalSalaryAmount: "Total (Salary amount)",
        totalMPFSubsidy: "Total (MPF Subsidy)",
        specify: "( Please specify the reason )",
        otherReason: "Reason for other paid leave",
        validReason: "reason",
        courseId: "Course ID",
        confirm: "Confirm",
        tooltip1:
            "Schools could claim reimbursement of salaries of the supply teachers substituting the teachers remunerated under Salaries Grant who are on paternity leave, on condition that the teachers are approved to take leave for 3 or more consecutive days. For details, please refer to EDB Circular No. 16/2015. ",
        tooltip2:
            "For granting of leave, schools should follow EDB Circular No. 1/2006 and No. 16/2015 (applicable to paternity leave).",
        partCLabel:
            "My school will refund to the Government any over-payment of grant.",

        signDate: "Date",
        signContactPerson: "Contact Person",
        signTelNo: "Tel No.",
        signSsdo: "SSDO",
    },
    noteList: {
        noteOne: "Enter Staff Reference Number of teachers on leave.",
        noteTwo:
            "Enter the alphabet from the list of reasons for absence below -",
        noteTwoB:
            "For granting of leave, schools should follow EDB Circular No. 1/2006 and No. 16/2015 (applicable to paternity leave).",
        noteThree:
            "Please note that the daily-rated supply teacher grant claimed on a reimbursement basis is used for the hire of eligible daily-rated supply teacher(s) to substitute the teacher(s) on approved leave. If the teaching duties and other duties of the teacher(s) on leave have been delegated to other school personnel, schools are not allowed to apply for the above claim.",
        noteFour:
            "The number of working days should exclude Sunday, Saturday (short-week), public holidays, discretionary holidays or any days on which the teachers are not required to perform duties.",
        noteFive:
            "Please refer to relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools.",
        noteSix:
            "For supply period less than 60 calendar days yet the supply teacher is required to contribute to MPF, please provide supporting information.",
        noteSeven:
            "For temporary teachers appointed on monthly term, please submit appointment form available from EDB Homepage (http://www.edb.gov.hk School Administration and Management -> Administration -> About School Staff -> Appointment Matters)",
    },
    statementList: [
        {
            text: "I certify that *–",
        },
        {
            text: "the emoluments have been paid to the supply teacher and/or MPF scheme trustee concerned, relevant receipts being attached for your record;",
        },
        {
            text: "the claim(s) above do not fall within the ambits of the Teacher Relief Grant (TRG);",
        },
        {
            text: "this request for payment complies with the conditions set out for TRG applications;",
        },
        {
            text: {
                t1: "the school ",
                t2: " surplus teachers and the number of surplus teachers has been offset before employing any supply teachers;",
                t3: "",
            },
        },
        {
            text: "no duplicate claim has been made for government subventions on account of the same leave/vacancy set out above, such as the encashment of Additional Teaching Posts for English and the fractional staff entitlement for claiming Fractional Post Cash Grant,",
        },
        {
            text: "the school has approved the paternity leave taken by the above teachers within the establishment in accordance with the related rules, and",
        },
        {
            text: "the school has verified the teacher registration documents of the supply teacher, and with the supply teacher’s consent, applied to the EDB for the release of the teacher registration information.",
        },
    ],

    statemenStep: [
        {
            step: "(i)",
        },
        {
            step: "(ii)",
        },
        {
            step: "(iii)",
        },
        {
            step: "(iv)",
        },
        {
            step: "(v)",
        },
        {
            step: "(vi)",
        },
        {
            step: "(vii)",
        },
    ],

    errorMsg: {
        numLimit: "Please enter {{limit}}",
        dayslimit1:
            "Schools could claim reimbursement of salaries of the supply teachers for teachers on leaves lasting for 30 to 89 calendar days, except for:",
        dayslimit2:
            "teacher(s) on paternity leave lasting for 3 or more consecutive days, and/or ",
        dayslimit3:
            "number of teachers on leave for 3 or more consecutive days at the same time exceeds the no. of surplus teacher(s) if the school ceased receiving annual recurrent grant of TRG in the school year after packing of classes.",
        // leaveDate:
        //     "The deadline shall not be later than August 31 of the academic year of the subject",
        supplyDate:
            "The start date of supply period should be within the leave period",
        supplyDateEnd:
            "The end date of supply period should be within the leave period",
        contractDate:
            "the deadline shall not be later than August 31 of the academic year of the subject",
        date: {
            year: "Please input a valid year",
        },
        number: {
            min: "The minimum value of this field must be greater than 0",
        },
        paternityLeave:
            "paid paternity leave, then leave period >= 3 calendar days.",
        workDays: "The working days cannot be greater than Supply period days",
        E0001: "Please input a valid contact person",
    },
};
export default Form070EN;
